import type { IconSvgObject } from './types';

const BrushIcon: IconSvgObject = [
  ["path", { d: "M11.1859 9.79239L14.1626 12.7495M9.87052 16.6178C11.1647 15.5837 12.965 13.9396 14.4108 12.5033C18.7947 8.14809 21.6822 3.95551 20.8602 3.13887C20.0382 2.32224 15.8179 5.19079 11.434 9.54596C9.98813 10.9823 8.33297 12.7706 7.29206 14.0563M8.95338 19.4031C6.72086 21.621 3 20.8817 3 20.8817C4.11626 18.2942 2.62791 16.8156 4.48834 14.9674C5.72133 13.7425 7.72039 13.7425 8.95338 14.9674C10.1864 16.1923 10.1864 18.1782 8.95338 19.4031Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default BrushIcon;
